"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const array_1 = require("../../common/js/helper/array");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
const Salutations_1 = __importDefault(require("../enums/Salutations"));
class MassiveCompany {
    api = new ecommerce_1.MassiveCompanyApi(configuration_1.default);
    loading = false;
    initialized = false;
    internalCompany = null;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            loading: mobx_1.observable,
            initialized: mobx_1.observable,
            internalCompany: mobx_1.observable,
            isInitialized: mobx_1.computed,
            isLoading: mobx_1.computed,
            company: mobx_1.computed,
            massiveCustomer: mobx_1.computed,
            customer: mobx_1.computed,
            salutation: mobx_1.computed,
            salutationDisplayName: mobx_1.computed,
            loadCompany: mobx_1.action.bound,
        });
    }
    get isInitialized() {
        return this.initialized;
    }
    get isLoading() {
        return this.loading;
    }
    get company() {
        return this.internalCompany;
    }
    get massiveCustomer() {
        return (0, array_1.first)(this.company?.massiveCustomers ?? []) ?? null;
    }
    get customer() {
        return this.massiveCustomer?.customer ?? null;
    }
    get salutation() {
        return this.customer?.salutation ?? null;
    }
    get salutationDisplayName() {
        const salutation = this.salutation;
        if (!salutation) {
            return null;
        }
        if (Salutations_1.default.notSpecified === salutation.salutationKey) {
            return null;
        }
        return salutation.translated?.displayName ?? null;
    }
    initialize() {
        if (!AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.COMPANY_READ) || this.initialized || this.loading) {
            return Promise.resolve(null);
        }
        return this.loadCompany().finally(() => {
            this.initialized = true;
        });
    }
    loadCompany() {
        this.loading = true;
        return this.api
            .readMassiveCompanyList()
            .then((0, mobx_1.action)((companies) => {
            this.internalCompany = (0, array_1.first)(companies) ?? null;
            return this.internalCompany;
        }))
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
    reset() {
        this.initialized = false;
        this.internalCompany = null;
    }
    validateCompanyData(requestParameters) {
        return this.api.validateCompanyData(requestParameters).then((result) => result.data);
    }
    updateMassiveCompany(requestParameters) {
        return this.api.updateMassiveCompany(requestParameters);
    }
    validateTaxId(countryCode, taxId) {
        return this.api.validateTaxId({ taxIdValidation: { countryCode, taxId } });
    }
}
exports.default = new MassiveCompany();
